export class ProposalConst {
    public static readonly noAnswerDefaultText: string = 'Unknown';
}
